import logo from "../assets/logo.png";

function Footer() {
  return (
    <footer className="p-4 bg-kuning rounded-lg shadow md:px-6 md:py-4 dark:bg-gray-900">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div className="flex items-center mb-4 sm:mb-0">
          <img src={logo} className="mr-1 h-8" alt="Rotten Berries Logo" />
          <span className="self-center text-biru text-xl font-semibold whitespace-nowrap dark:text-white">
            Rotten Berries
          </span>
        </div>
      </div>
      <span className="block text-md font-semibold text-biru sm:text-center dark:text-gray-400">
        © 2022 EKPP production . All Rights Reserved.
      </span>
    </footer>
  );
}

export default Footer;
